import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import LoginModal from './components/shared/LoginModal';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Accommodation from './pages/Accommodation';
import Events from './pages/Events';
import EventBooking from './pages/EventBooking';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Booking from './pages/Booking';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import MyOrders from './pages/Customer/MyOrders';
import MyBookings from './pages/Customer/MyBookings';
import PaymentConfirmation from './pages/PaymentConfirmation';
import { AuthProvider } from './context/AuthContext';
import CartProvider from './context/CartContext';
import BookingProvider from './context/BookingContext';

// Admin Components
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './pages/Admin/Dashboard';
import AdminIndex from './pages/Admin/index';
import OrdersManagement from './pages/Admin/OrdersManagement';
import BookingsManagement from './pages/Admin/BookingsManagement';
import MenuManagement from './pages/Admin/MenuManagement';
import PaymentsManagement from './pages/Admin/PaymentsManagement';
import UserManagement from './pages/Admin/UserManagement';
import AnalyticsDashboard from './pages/Admin/AnalyticsDashboard';

import './styles/index.css';

const App = () => {
  return (
    <Router>
      <CartProvider>
        <BookingProvider>
          <AuthProvider>
            <Routes>
              {/* Admin Routes (No Header/Footer) */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="menu" element={<MenuManagement />} />
                <Route path="orders" element={<OrdersManagement />} />
                <Route path="bookings" element={<BookingsManagement />} />
                <Route path="payments" element={<PaymentsManagement />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="analytics" element={<AnalyticsDashboard />} />
                <Route path="settings" element={<AdminIndex />} />
              </Route>

              {/* Public Routes with Header/Footer */}
              <Route
                path="*"
                element={
                  <div className="min-h-screen flex flex-col">
                    <Header />
                    <LoginModal />
                    <main className="flex-1">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/menu" element={<Menu />} />
                        <Route path="/accommodation" element={<Accommodation />} />
                        <Route path="/booking" element={<Booking />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/event-booking" element={<EventBooking />} />
                        <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/checkout" element={<Checkout />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/my-orders" element={<MyOrders />} />
                        <Route path="/my-bookings" element={<MyBookings />} />
                      </Routes>
                    </main>
                    <Footer />
                  </div>
                }
              />
            </Routes>
          </AuthProvider>
        </BookingProvider>
      </CartProvider>
    </Router>
  );
};

export default App;